function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .af137ad7-8ebb-4659-81e0-b8ad85d4fd34 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bfd3800d-0ddc-403b-8c07-6574fbb77722",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "af137ad7-8ebb-4659-81e0-b8ad85d4fd34",
  d: "M49.3,17.13l-.12-.05,0-.12a19.89,19.89,0,0,0-38.3,0l0,.12-.12.05A14.54,14.54,0,0,0,16.52,45H23V42.83H16.54A12.38,12.38,0,0,1,4.18,30.44a12.43,12.43,0,0,1,7.88-11.52l.74-.72a17.71,17.71,0,0,1,34.4,0l.75.85a12.38,12.38,0,0,1-4.49,23.77H37V45h6.48A14.54,14.54,0,0,0,49.3,17.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "af137ad7-8ebb-4659-81e0-b8ad85d4fd34",
  d: "M41.34,35.28a1.21,1.21,0,0,0,.76-1.09,1.1,1.1,0,0,0-.36-.8L31.21,22.75a1.47,1.47,0,0,0-2.08,0L18.64,33.39a1.14,1.14,0,0,0-.36.8,1.22,1.22,0,0,0,.77,1.09A1.05,1.05,0,0,0,20.26,35l8-8c.26-.26.46-.23.56-.19s.26.16.26.52V56.41a1.15,1.15,0,0,0,2.29,0V27.35c0-.36.16-.48.26-.52s.3-.07.56.19l8,8A1.05,1.05,0,0,0,41.34,35.28Z"
})));

var SvgIconUpload = function SvgIconUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_upload.d7332aad.svg";
export { ForwardRef as ReactComponent };